var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1188,
    height: 1162,
    viewBox: "0 0 1188 1162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_15295)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.254 1173.26C177.029 1162.2 171.674 1145.55 163.274 1125.96C158.913 1115.79 155.423 1108.76 146.294 1090.79C114.449 1028.08 111.534 1024.19 113.547 1015.59C117.842 997.246 138.482 983.55 155.997 971.927C172.043 961.279 178.916 961.098 182.679 952.521C188.705 938.789 175.457 929.281 166.913 899.156C159.967 874.667 160.98 853.656 162.061 831.237C163.158 808.478 166.795 790.231 168.125 783.935C174.343 754.496 180.35 748.492 180.254 728.144C180.167 709.666 175.121 695.287 172.977 689.333C168.65 677.323 165.093 673.451 147.507 640.819C141.343 629.383 138.262 623.665 136.591 620.201C129.951 606.432 116.526 577.924 114.76 541.366C114.041 526.492 113.682 519.055 117.185 509.832C121.549 498.343 128.067 493.635 141.442 474.659C149.336 463.46 153.247 457.835 154.784 454.041C163.528 432.451 154.911 409.809 152.358 403.101C140.832 372.814 122.615 372.505 115.973 349.736C111.475 334.315 116.319 322.418 126.888 293.945C163.395 195.597 165.346 176.595 181.466 173.873C200.797 170.609 229.309 192.648 234.832 196.917C245.797 205.394 250.569 212.271 260.302 212.684C275.636 213.335 287.86 197.285 291.836 192.066C311.834 165.809 300.649 147.721 313.667 124.146C327.942 98.295 357.978 90.0083 392.502 80.4835C416.56 73.8463 452.24 64.0024 490.743 76.8449C531.532 90.4499 541.83 118.289 573.216 114.443C583.266 113.212 593.258 107.558 613.241 96.2505C643.672 79.0311 649.292 68.2531 667.818 64.7164C681.562 62.0926 689.293 65.958 711.481 71.9935C753.885 83.5277 748.168 75.5343 830.34 91.3991C830.34 91.3991 856.864 96.5201 892.195 102.315C910.982 105.396 914.545 105.763 918.878 105.953C947.298 107.204 951.873 98.3849 979.52 96.2505C992.133 95.2767 986.834 97.4478 1048.65 105.953C1053.9 106.675 1061.7 107.727 1069.27 113.23C1079.35 120.553 1077.78 127.584 1085.04 135.062C1093.57 143.849 1104.34 142.994 1142.85 145.169C1142.85 145.169 1161.03 146.196 1178.43 147.594C1203.93 149.645 1226.21 385.887 1228.56 1223.8",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.254 1173.26C177.029 1162.2 171.674 1145.55 163.274 1125.96C158.913 1115.79 155.423 1108.76 146.294 1090.79C114.449 1028.08 111.534 1024.19 113.547 1015.59C117.842 997.246 138.482 983.55 155.997 971.927C172.043 961.279 178.916 961.098 182.679 952.521C188.705 938.789 175.457 929.281 166.913 899.156C159.967 874.667 160.98 853.656 162.061 831.237C163.158 808.478 166.795 790.231 168.125 783.935C174.343 754.496 180.35 748.492 180.254 728.144C180.167 709.666 175.121 695.287 172.977 689.333C168.65 677.323 165.093 673.451 147.507 640.819C141.343 629.383 138.262 623.665 136.591 620.201C129.951 606.432 116.526 577.924 114.76 541.366C114.041 526.492 113.682 519.055 117.185 509.832C121.549 498.343 128.067 493.635 141.442 474.659C149.336 463.46 153.247 457.835 154.784 454.041C163.528 432.451 154.911 409.809 152.358 403.101C140.832 372.814 122.615 372.505 115.973 349.736C111.475 334.315 116.319 322.418 126.888 293.945C163.395 195.597 165.346 176.595 181.466 173.873C200.797 170.609 229.309 192.648 234.832 196.917C245.797 205.394 250.569 212.271 260.302 212.684C275.636 213.335 287.86 197.285 291.836 192.066C311.834 165.809 300.649 147.721 313.667 124.146C327.942 98.295 357.978 90.0083 392.502 80.4835C416.56 73.8463 452.24 64.0024 490.743 76.8449C531.532 90.4499 541.83 118.289 573.216 114.443C583.266 113.212 593.258 107.558 613.241 96.2505C643.672 79.0311 649.292 68.2531 667.818 64.7164C681.562 62.0926 689.293 65.958 711.481 71.9935C753.886 83.5277 748.168 75.5343 830.34 91.3991C830.34 91.3991 856.864 96.5202 892.195 102.315C910.982 105.396 914.545 105.763 918.878 105.953C947.298 107.204 951.873 98.3849 979.52 96.2505C992.133 95.2767 986.834 97.4478 1048.65 105.953C1053.9 106.675 1061.7 107.727 1069.27 113.23C1079.35 120.553 1077.78 127.584 1085.04 135.062C1093.57 143.849 1104.34 142.994 1142.85 145.169C1142.85 145.169 1161.03 146.196 1178.43 147.594C1203.93 149.645 1226.21 385.887 1228.56 1223.8",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1167.11 31.9697H14.0938V1135.66H1167.11V31.9697Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.276 1180.13C257.582 1177.05 255.646 1158.58 243.721 1138.09C231.941 1117.84 222.714 1116.76 217.847 1100.89C211.564 1080.41 220.222 1060.28 224.316 1050.76C230.971 1035.29 234.755 1037.66 251.807 1008.72C263.313 989.191 266.473 979.829 267.979 974.758C271.997 961.223 272.506 950.407 272.83 942.415C273.544 924.792 274.471 901.904 263.127 880.964C253.934 863.993 247.693 868.63 232.402 848.621C225.161 839.145 205.144 812.953 208.145 782.319C209.229 771.245 213.268 760.142 221.082 738.656C227.225 721.766 228.475 722.088 229.168 716.017C231.878 692.256 213.014 684.85 216.23 665.885C218.454 652.777 227.817 654.249 237.253 631.926C240.612 623.979 244.679 614.358 243.721 602.817C242.975 593.826 239.391 586.232 224.316 567.241C198.034 534.132 190.403 533.879 183.888 517.109C181.739 511.576 175.189 494.717 180.654 476.681C187.044 455.591 203.677 453.306 203.294 439.487C202.809 422.058 176.133 417.931 175.802 399.059C175.66 390.884 180.645 390.492 188.739 369.951C194.562 355.176 197.472 347.789 196.825 340.842C194.72 318.262 166.55 313.088 166.099 293.945C165.857 283.646 173.729 273.088 182.271 268.071C209.093 252.317 239.048 293.229 279.299 282.625C300.752 276.974 313.825 259.668 324.578 245.431C345.525 217.702 355.962 178.983 358.538 169.426C364.098 148.799 363.595 141.516 369.858 138.701C389.82 129.727 430.04 187.927 441.012 180.746C445.23 177.985 439.984 168.927 441.012 150.021C441.605 139.099 443.041 112.7 460.417 99.8897C477.032 87.6417 504.282 90.72 520.251 103.124C533.125 113.124 528.757 121.488 549.359 153.255C567.643 181.447 576.848 183.748 581.702 183.98C590.088 184.382 596.558 179.145 604.342 172.661C626.637 154.09 621.998 141.803 636.684 130.615C645.848 123.635 648.671 127.643 707.839 120.912C723.042 119.183 730.244 118.078 743.415 117.678C780.237 116.56 789.01 123.221 791.929 125.764C801.275 133.906 797.957 141.094 806.483 146.786C818.406 154.747 830.336 144.326 853.38 141.935C889.526 138.185 892.724 160.445 929.385 156.489C946.561 154.636 958.15 148.423 974.665 154.872C984.872 158.858 983.423 162.394 992.454 166.192C1014.64 175.526 1029.81 156.87 1060.37 159.724C1069.37 160.563 1063.24 161.73 1094.33 171.043C1129.33 181.526 1145.12 182.449 1159.02 180.746C1168.84 179.542 1172.92 177.613 1175.19 177.512C1220.29 175.5 1550.13 853.713 1214 1194.69C892.953 1520.37 269.281 1229.06 258.276 1180.13Z",
    fill: "#9E1F63",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M565.531 1170.43C580.11 1155 598.844 1130.05 601.108 1097.66C603.384 1065.1 586.801 1056.74 591.405 1032.97C599.367 991.877 652.705 997.49 696.519 942.414C730.197 900.079 711.143 881.099 746.65 845.387C763.906 828.031 766.436 834.495 845.295 790.404C884.908 768.256 896.393 759.847 922.917 751.593C927.322 750.222 936.683 746.065 949.775 743.867C965.951 741.151 989.766 737.153 1002.16 748.359C1018.68 763.303 1008.84 799.932 1002.16 825.981C993.47 859.822 980.343 877.858 985.985 882.58C992.434 887.979 1007.69 862.833 1040.97 858.324C1066.53 854.86 1083.74 866.147 1100.8 853.472C1103.47 851.488 1106.36 847.837 1112.12 840.535C1130 817.893 1130.05 808.59 1139.61 801.724C1139.61 801.724 1154.72 790.881 1178.42 798.49C1199.78 805.342 1217.33 870.571 1175.19 1178.52",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.531 1170.43C580.11 1155 598.844 1130.05 601.108 1097.66C603.384 1065.1 586.801 1056.74 591.405 1032.97C599.367 991.877 652.705 997.49 696.519 942.414C730.197 900.079 711.143 881.099 746.65 845.387C763.906 828.031 766.436 834.495 845.295 790.404C884.908 768.256 896.393 759.847 922.917 751.593C927.321 750.222 936.683 746.065 949.775 743.867C965.951 741.151 989.766 737.153 1002.16 748.359C1018.68 763.303 1008.84 799.932 1002.16 825.981C993.47 859.822 980.343 877.858 985.985 882.58C992.434 887.979 1007.69 862.833 1040.97 858.324C1066.53 854.86 1083.74 866.147 1100.8 853.472C1103.47 851.488 1106.36 847.837 1112.12 840.535C1130 817.893 1130.05 808.59 1139.61 801.724C1139.61 801.724 1154.72 790.881 1178.42 798.49C1199.78 805.342 1217.33 870.571 1175.19 1178.52",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M605.957 1172.05C604.813 1165.64 602.452 1147.39 612.965 1130C618.761 1120.41 626.091 1115.03 630.753 1111.67C646.138 1100.6 661.692 1098.37 671.181 1097.12C682.642 1095.61 690.799 1096.39 704.063 1097.66C724.668 1099.63 737.218 1100.83 751.499 1107.36C770.992 1116.28 769.623 1124.11 788.693 1130.54C801.384 1134.82 812.33 1134.84 822.114 1134.85C839.456 1134.88 848.76 1134.9 856.612 1128.92C866.247 1121.6 862.428 1113.83 871.706 1095.5C875.108 1088.78 885.562 1068.14 906.204 1057.77C919.249 1051.22 923.906 1055.03 943.398 1045.37C952.435 1040.9 953.499 1039.05 963.343 1034.59C971.976 1030.68 981.335 1026.43 994.068 1024.89C1000.42 1024.12 1014.97 1022.51 1030.72 1028.66C1045.36 1034.37 1046.79 1041.22 1056.6 1041.06C1062.23 1040.97 1063.52 1038.68 1080.85 1028.66C1094.09 1021.01 1100.7 1017.19 1109.42 1014.11C1119.73 1010.47 1117.73 1013.06 1135.3 1008.18C1148.33 1004.56 1154.78 1001.65 1166.02 1001.71C1171.12 1001.74 1175.86 1002.37 1177.34 1002.79C1199.55 1009.04 1180.03 1161.6 1177.88 1177.98",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.957 1172.05C604.813 1165.64 602.452 1147.39 612.965 1130C618.761 1120.41 626.091 1115.03 630.753 1111.67C646.138 1100.6 661.692 1098.37 671.181 1097.12C682.642 1095.61 690.799 1096.39 704.063 1097.66C724.668 1099.63 737.218 1100.83 751.499 1107.36C770.992 1116.28 769.623 1124.11 788.693 1130.54C801.384 1134.82 812.33 1134.84 822.114 1134.85C839.456 1134.88 848.76 1134.9 856.612 1128.92C866.247 1121.6 862.428 1113.83 871.706 1095.5C875.108 1088.78 885.562 1068.14 906.204 1057.77C919.249 1051.22 923.906 1055.03 943.398 1045.37C952.435 1040.9 953.499 1039.05 963.343 1034.59C971.976 1030.68 981.335 1026.43 994.068 1024.89C1000.42 1024.12 1014.97 1022.51 1030.72 1028.66C1045.36 1034.37 1046.79 1041.22 1056.6 1041.06C1062.23 1040.97 1063.52 1038.68 1080.85 1028.66C1094.09 1021.01 1100.7 1017.19 1109.42 1014.11C1119.73 1010.47 1117.73 1013.06 1135.3 1008.18C1148.33 1004.56 1154.78 1001.65 1166.02 1001.71C1171.12 1001.74 1175.86 1002.37 1177.34 1002.79C1199.55 1009.04 1180.03 1161.6 1177.88 1177.98",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.536 1170.43C275.15 1143.84 268.892 1122.72 264.748 1108.98C253.614 1072.07 248.939 1059.31 255.045 1044.29C259.235 1034 266.463 1028.26 280.919 1016.8C280.919 1016.8 293.853 1006.55 339.136 984.461C351.066 976.397 357.827 967.957 361.776 961.821C368.135 951.938 367.802 947.096 376.33 932.713C383.235 921.066 386.688 915.243 392.501 911.69C406.269 903.276 418.337 912.153 426.461 905.221C436.435 896.711 429.692 873.566 428.078 868.027C413.729 818.778 374.434 817.58 365.01 777.468C358.145 748.244 372.346 720.551 376.33 712.783C385.374 695.147 391.281 696.165 407.056 675.589C416.897 662.752 452.73 616.012 441.016 567.241C438.228 555.636 436.08 546.693 428.078 539.75C408.116 522.429 380.246 542.308 335.902 526.813C326.591 523.559 317.101 518.938 310.028 515.493C288.514 505.016 277.757 499.777 276.068 494.47C270.224 476.115 312.482 432.942 360.159 428.168C378.738 426.307 383.281 431.766 419.992 429.785C441.442 428.627 457.328 425.823 471.741 415.231C475.747 412.287 482.555 407.284 486.295 400.677C506.483 365.017 422.011 309.669 434.547 248.666C439.035 226.827 455.507 206.45 474.975 200.152C502.091 191.38 531.314 211.123 550.98 224.409C550.98 224.409 559.084 229.884 601.111 268.072C621.718 269.128 649.565 266.874 670.648 248.666C679.225 241.259 678.529 238.252 688.436 227.643C720.078 193.761 764.129 184.858 764.441 185.598C764.695 186.198 737.427 195.972 738.567 200.152C739.637 204.074 764.171 197.435 806.487 195.301C847.682 193.224 851.241 198.164 882.492 193.684C902.634 190.796 906.421 187.989 929.389 185.598C957.103 182.714 970.96 181.271 982.754 187.215C1009.94 200.914 1017.47 241.849 1016.71 242.198C1016.16 242.453 1007.47 222.578 1007.01 222.792C1006.41 223.075 1013.51 261.463 1040.97 277.775C1045.47 280.448 1043.97 278.635 1087.87 290.712C1118.22 299.061 1110 297.469 1121.83 300.414C1140.43 305.048 1147.25 305.623 1157.4 311.734C1164.58 316.056 1169.46 320.762 1175.19 326.288C1175.19 326.288 1186.1 336.809 1194.6 348.928C1269.63 455.971 1223.71 733.805 1223.71 733.805C1205.65 843.044 1190.09 995.352 1199.45 1191.45",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.536 1170.43C275.15 1143.84 268.892 1122.72 264.748 1108.98C253.614 1072.07 248.939 1059.31 255.045 1044.29C259.235 1034 266.463 1028.26 280.919 1016.8C280.919 1016.8 293.853 1006.55 339.136 984.461C351.066 976.397 357.827 967.957 361.776 961.821C368.135 951.938 367.802 947.096 376.33 932.713C383.235 921.066 386.688 915.243 392.501 911.69C406.269 903.276 418.337 912.153 426.461 905.221C436.435 896.711 429.692 873.566 428.078 868.027C413.729 818.778 374.434 817.58 365.01 777.468C358.145 748.244 372.346 720.551 376.33 712.783C385.374 695.147 391.281 696.165 407.056 675.589C416.897 662.752 452.73 616.012 441.016 567.241C438.228 555.636 436.08 546.693 428.078 539.75C408.116 522.429 380.246 542.308 335.902 526.813C326.591 523.559 317.101 518.938 310.028 515.493C288.514 505.016 277.757 499.777 276.068 494.47C270.224 476.115 312.482 432.942 360.159 428.168C378.738 426.307 383.281 431.766 419.992 429.785C441.442 428.627 457.328 425.823 471.741 415.231C475.747 412.287 482.555 407.284 486.295 400.677C506.483 365.017 422.011 309.669 434.547 248.666C439.035 226.827 455.507 206.45 474.975 200.152C502.091 191.38 531.314 211.123 550.98 224.409C550.98 224.409 559.084 229.884 601.111 268.072C621.718 269.128 649.565 266.874 670.648 248.666C679.225 241.259 678.529 238.252 688.436 227.643C720.078 193.761 764.129 184.858 764.441 185.598C764.695 186.198 737.427 195.972 738.567 200.152C739.637 204.074 764.17 197.435 806.487 195.301C847.682 193.224 851.241 198.164 882.492 193.684C902.634 190.796 906.421 187.989 929.389 185.598C957.103 182.714 970.96 181.271 982.754 187.215C1009.94 200.914 1017.47 241.849 1016.71 242.198C1016.16 242.453 1007.47 222.578 1007.01 222.792C1006.41 223.075 1013.51 261.463 1040.97 277.775C1045.47 280.448 1043.97 278.635 1087.87 290.712C1118.22 299.061 1110 297.469 1121.83 300.414C1140.43 305.048 1147.25 305.623 1157.4 311.734C1164.58 316.056 1169.46 320.762 1175.19 326.288C1175.19 326.288 1186.1 336.809 1194.6 348.928C1269.63 455.971 1223.71 733.805 1223.71 733.805C1205.65 843.044 1190.09 995.352 1199.45 1191.45",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.16 1172.05C446.237 1152.94 443.191 1142.59 441.012 1138.09C438.071 1132.01 433.075 1129.09 408.669 1117.07C380.604 1103.24 374.357 1100.78 374.709 1097.66C375.473 1090.89 406.123 1092.09 436.16 1075.02C440.08 1072.79 446.095 1069.06 450.714 1062.08C457.132 1052.39 457.07 1042.18 457.182 1036.21C457.71 1008.33 463.193 1014.18 465.268 976.375C466.625 951.659 464.155 951.447 465.268 916.541C465.91 896.418 466.276 886.152 468.503 876.112C473.93 851.644 484.147 836.274 491.142 825.981C499.829 813.199 504.3 806.804 510.548 806.576C522.371 806.144 534.955 826.569 539.656 845.387C548.685 881.528 525.198 897.979 531.571 945.649C533.37 959.105 536.622 968.123 539.656 976.375C544.682 990.041 552.776 1012.05 562.296 1011.95C568.766 1011.89 571.828 1001.65 581.702 982.843C597.393 952.95 601.146 956.906 615.662 929.478C631.977 898.65 640.156 883.195 635.067 866.41C632.896 859.248 630.877 860.312 610.81 830.833C601.411 817.025 596.711 810.121 593.022 803.342C584.308 787.33 574.381 769.088 575.233 746.742C576.043 725.493 586.236 710.096 593.022 699.845C610.997 672.69 623.338 677.683 636.684 654.566C646.995 636.706 652.386 611.628 648.004 588.263C644.439 569.253 637.064 565.558 639.919 554.303C643.541 540.025 657.471 537.866 685.198 518.726C707.205 503.536 721.715 488.822 732.095 478.298C743.602 466.63 752.703 454.887 770.906 431.401C792.996 402.901 804.218 388.309 812.952 371.568C818.205 361.496 826.457 345.451 832.357 323.054C836.086 308.898 838.819 292.42 840.443 282.625C845.567 251.722 844.866 243.468 851.762 238.963C863.284 231.435 882.975 242.892 887.34 245.431C923.031 266.199 935.582 313.372 932.619 314.968C930.276 316.23 914.364 291.07 914.831 290.711C915.303 290.348 933.866 314.365 971.43 360.248C983.43 374.905 983.928 375.367 994.07 387.739C1048.42 454.042 1073.98 489.738 1076.54 488.001C1078.78 486.486 1063.15 456.755 1061.99 457.275C1060.46 457.964 1077.81 514.381 1095.95 513.875C1103.96 513.652 1104.54 502.526 1120.21 491.235C1133.22 481.855 1155.42 473.257 1167.1 481.533C1172.37 485.265 1175.28 492.268 1175.19 521.961C1175.08 558.814 1170.53 571.413 1170.34 591.497C1169.99 628.059 1184.67 626.857 1188.13 664.268C1193.22 719.306 1163.59 745.046 1180.04 770.999C1191.05 788.361 1211.6 787.486 1223.7 793.639C1258.32 811.245 1265.07 906.043 1186.51 1188.22",
    fill: "#9E1F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.16 1172.05C446.237 1152.94 443.191 1142.59 441.012 1138.09C438.071 1132.01 433.075 1129.09 408.669 1117.07C380.604 1103.24 374.357 1100.78 374.709 1097.66C375.473 1090.89 406.123 1092.09 436.16 1075.02C440.08 1072.79 446.095 1069.06 450.714 1062.08C457.132 1052.39 457.07 1042.18 457.182 1036.21C457.71 1008.33 463.193 1014.18 465.268 976.375C466.625 951.659 464.155 951.447 465.268 916.541C465.91 896.418 466.276 886.152 468.503 876.112C473.93 851.644 484.147 836.274 491.142 825.981C499.829 813.199 504.3 806.804 510.548 806.576C522.371 806.144 534.955 826.569 539.656 845.387C548.685 881.528 525.198 897.979 531.571 945.649C533.37 959.105 536.622 968.123 539.656 976.375C544.682 990.041 552.776 1012.05 562.296 1011.95C568.766 1011.89 571.828 1001.65 581.702 982.843C597.393 952.95 601.146 956.906 615.662 929.478C631.977 898.65 640.156 883.195 635.067 866.41C632.896 859.248 630.877 860.312 610.81 830.833C601.411 817.025 596.711 810.121 593.022 803.342C584.308 787.33 574.381 769.088 575.233 746.742C576.043 725.493 586.236 710.096 593.022 699.845C610.997 672.69 623.338 677.683 636.684 654.566C646.995 636.706 652.386 611.628 648.004 588.263C644.439 569.253 637.064 565.558 639.919 554.303C643.541 540.025 657.471 537.866 685.198 518.726C707.205 503.536 721.715 488.822 732.095 478.298C743.602 466.63 752.703 454.887 770.906 431.401C792.996 402.901 804.218 388.309 812.952 371.568C818.205 361.496 826.457 345.451 832.357 323.054C836.086 308.898 838.819 292.42 840.443 282.625C845.567 251.722 844.867 243.468 851.762 238.963C863.284 231.435 882.975 242.892 887.34 245.431C923.031 266.199 935.582 313.372 932.619 314.968C930.276 316.23 914.364 291.07 914.831 290.711C915.303 290.348 933.866 314.365 971.43 360.248C983.43 374.905 983.928 375.367 994.07 387.739C1048.42 454.042 1073.98 489.738 1076.54 488.001C1078.78 486.486 1063.15 456.755 1061.99 457.275C1060.46 457.964 1077.81 514.381 1095.95 513.875C1103.96 513.652 1104.54 502.526 1120.21 491.235C1133.22 481.855 1155.42 473.257 1167.1 481.533C1172.37 485.265 1175.28 492.268 1175.19 521.961C1175.08 558.814 1170.53 571.413 1170.34 591.497C1169.99 628.059 1184.67 626.857 1188.13 664.268C1193.22 719.306 1163.59 745.046 1180.04 770.999C1191.05 788.361 1211.6 787.486 1223.7 793.639C1258.32 811.245 1265.07 906.043 1186.51 1188.22",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1454.15 1346.75V-26L1167.11 -26V1346.75H1454.15Z",
    fill: "#6C3950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.272 183.096H433.734V441.913H522.272V183.096Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.662 660.377H217.914V748.763H501.662V660.377Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.5 794.852H238.461V884.602H506.5V794.852Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.501 944.031H210.57V1001.71H449.501V944.031Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.501 1100.49H210.57V1135.66H449.501V1100.49Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.512 884.603H449.508V1135.66H506.512V884.603Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89 520.747H245.75V594.731H428.89V520.747Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.28 496.49H428.891V545.004H522.28V496.49Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.693 371.567H83.2188V406.74H374.693V371.567Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.491 274.539H202.086V330.33H372.491V274.539Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.692 206.619H313.664V252.707H410.692V206.619Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.904 126.571H83.2188V166.595H217.904V126.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.57 135.062H261.508V183.094H354.57V135.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.885 82.9102H268.789V118.083H428.885V82.9102Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.93 165.383H602.32V213.897H1055.93V165.383Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.81 172.66H1094.74V252.708H1157.81V172.66Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.621 262.411H602.32V406.74H649.621V262.411Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.906 330.33H649.625V382.483H713.906V330.33Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.876 252.709H791.531V356.408H861.876V252.709Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.522 262.411H926.156V347.311H979.522V262.411Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.51 347.311H1065.63V568.049H1110.51V347.311Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.64 280.604H1028.04V356.407H1065.64V280.604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.59 280.604H1065.63V330.33H1099.59V280.604Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.98 457.68H590.594V604.434H645.98V457.68Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.562 467.517H643.695V517.109H662.562V467.517Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.132 448.111H662.562V527.351H691.132V448.111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.739 418.465H713.906V517.11H754.739V418.465Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.524 372.645H769.297V438.408H811.524V372.645Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.69 660.377H590.594V771.807H643.69V660.377Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.52 649.714H617.148V674.779H658.52V649.714Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.406 737.038H681.766V771.806H790.406V737.038Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.286 771.808H691.125V792.022H769.286V771.808Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.886 781.914H590.594V982.843H611.886V781.914Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.069 837.301H611.891V951.039H635.069V837.301Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.985 690.143H676.844V727.337H771.985V690.143Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.43 595.271H658.523V636.777H750.43V595.271Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.166 529.238H809.312V583.816H852.166V529.238Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.381 537.323H876.023V604.434H922.381V537.323Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.013 595.271H783.312V636.777H862.013V595.271Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.257 636.777H783.312V673.702H803.257V636.777Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.748 673.701H783.312V703.079H830.748V673.701Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.29 414.421H999.734V462.531H1033.29V414.421Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.83 427.763H1033.29V462.531H1046.83V427.763Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.783 96.1152H902.969V141.664H979.783V96.1152Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.44 96.1152H1001.89V141.664H1047.44V96.1152Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.524 83.7178H581.297V135.062H791.524V83.7178Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.535 86.2012H801.695V145.17H867.535V86.2012Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.619 95.4424H465.68V162.958H516.619V95.4424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.29 95.4424H426.055V162.958H448.29V95.4424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.746 95.4424H516.617V131.424H528.746V95.4424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.673 95.4424H448.289V141.126H465.673V95.4424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.915 206.619H127.297V261.602H217.915V206.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.458 263.22H83.2188V320.224H162.458V263.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.093 737.578H125.672V863.175H159.093V737.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.976 769.381H159.102V839.726H184.976V769.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.129 901.986H82.5547V929.478H187.129V901.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.126 869.603H161.781V901.986H187.126V869.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.094 947.805H115.969V980.686H166.094V947.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27 1010.13H113.055V1048.35H151.27V1010.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.778 1010.13H151.266V1035.67H161.778V1010.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.126 1008.18H161.781V1068.55H187.126V1008.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.771 1010.13H214.078V1061H285.771V1010.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.434 1001.71H248.57V1010.13H273.434V1001.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.065 626.67H127.297V728.145H162.065V626.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.295 660.377H82.0156V695.117H127.295V660.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.733 559.559H116.773V628.287H150.733V559.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.295 615.754H82.0156V638.394H127.295V615.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.742 549.048H82.0156V574.518H131.742V549.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.689 482.341H84.8359V540.153H108.689V482.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.904 490.055H129.859V541.366H217.904V490.055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.494 580.177H171.766V619.392H240.494V580.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.745 531.125H206.125V561.783H245.745V531.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.731 339.225H381.578V426.954H433.731V339.225Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.886 392.36L918.719 361.619L833.865 469.733L873.032 500.474L957.886 392.36Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.64 492.216L1016.85 468.056L947.135 556.882L977.919 581.043L1047.64 492.216Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.57116,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.91 1135.66H-50V1358.83H1374.91V1135.66Z",
    fill: "#6C3950"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_15295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1188,
    height: 1162,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.373c9603eef25f22cdd4debb19ca8a02.svg";
export { ForwardRef as ReactComponent };